import { render, staticRenderFns } from "./BlocksDropDown.vue?vue&type=template&id=26f84fc4&scoped=true"
import script from "./BlocksDropDown.vue?vue&type=script&lang=js"
export * from "./BlocksDropDown.vue?vue&type=script&lang=js"
import style0 from "./BlocksDropDown.vue?vue&type=style&index=0&id=26f84fc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f84fc4",
  null
  
)

export default component.exports